export const environment = {
    URL: 'https://back.crediforza.credienlinea.co',
    USER: 'crediforza',
    PASS: '5lKSj6AgQxutS34',
    ENTERPRISE: 'Crediforza',
    SINGLEROUTE: true
  };
